import React from 'react'
import PropTypes from 'prop-types'

import { Button, Form } from 'semantic-ui-react'

import Container from './FASearchFormContainer'
import Enhancer from './FASearchFormEnhancer'

import FormInputText from 'Components/FormInputText'

import * as styles from './styles'

const FASearchForm = props => {
  const { form, handleInputChange, handleReset, handleSubmit } = props

  const { email } = form

  return (
    <Form size="tiny">
      <FormInputText
        autoCapitalize="off"
        autoComplete="off"
        icon="mail"
        name="email"
        onChange={handleInputChange}
        text="Email"
        value={email}
      />

      <Form.Group style={styles.buttonGroup}>
        <Button color="black" content="Search" icon="search" onClick={handleSubmit} />

        <Button color="black" content="Reset" icon="erase" onClick={handleReset} />
      </Form.Group>
    </Form>
  )
}

FASearchForm.propTypes = {
  form: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default Enhancer(Container(FASearchForm))
